import styled from 'styled-components'
// import { BREAK_POINT_MD } from '@CSSVars/variables'
import { CLICKABLE_COLOR_LIGHT } from '@CSSVars/colors'
import { Marker as MapBoxMarker } from 'react-map-gl'

export const _MapBoxMarker = styled(MapBoxMarker)`
  pointer-events: none;
  * {
    pointer-events: auto;
  }
  z-index: 0;
  ${({ enableLink }) => (enableLink && `
    pointer-events: auto;
  `)}
`


export const _MarkerContent = styled.div`
  width: 17px;
  height: 17px;
  border: 2px solid white;
  background-color: ${CLICKABLE_COLOR_LIGHT};
  border-radius: 50%;
  //transform: translate(-50%, -50%);
  &:hover {
    cursor: pointer;
  }

`
